<template>
  <section class="bloc-player-auto-full scroll-step js-scroll-show">
    <PlayerAutoVideoEmbed v-if="content.video && !content.video.video_provider" :content="content.video" />
    <PlayerAutoExternalEmbed v-else-if="content.video && content.video.video_provider" :content="content.video" />
  </section>
</template>

<script>
import PlayerAutoVideoEmbed from '@/components/PlayerAutoVideoEmbed.vue'
import PlayerAutoExternalEmbed from '@/components/PlayerAutoExternalEmbed.vue'

export default {
  name: 'PlayerFull',
  props: {
    content: {
      type: Object,
      required: true
    },
  },
  components: {
    PlayerAutoVideoEmbed,
    PlayerAutoExternalEmbed
  }
}
</script>

<style lang="scss">
  .bloc-player-auto-full {
    width: 100%;
    height: calc(100vh - 80px);
    overflow: hidden;
    position: relative;
    pointer-events: none;
  }
</style>
